var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { staticClass: "sprite-icon" },
    [
      _c("vue-client-only", [
        _c("use", { attrs: { "xlink:href": "#" + _vm.iconLink } })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }